import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import ForwardIcon from "@material-ui/icons/Forward";
import { Skeleton } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import { THEME_MODE } from "src/config/constants";
import PaperWrapper from "./PaperWrapper";

const useStyle = makeStyles((theme) => ({
  header: {
    borderBottom: `1px solid ${theme.palette.type === THEME_MODE.DARK ? "#263343" : "#D8DFEB"}`,
    marginBottom: "0.25rem",
    [theme.breakpoints.up("md")]: {
      height: "60px",
    },
  },
  root: {
    background: "#7994C1",
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    cursor: "pointer",
  },
  icon: {
    color: theme.palette.type === THEME_MODE.DARK ? "#000000" : "#FFFFFF",
    fontSize: "18px",
    cursor: "pointer",
  },
}));

export default function OverviewMonitoringWrapper({
  title,
  to,
  children,
  isLoading = false,
  overview,
  overviewProps,
  ...props
}) {
  const cls = useStyle();
  const history = useHistory();

  return (
    <PaperWrapper title={title} {...props}>
      <Grid container spacing={1} className={cls.header}>
        <Grid item sm={11} xs={10}>
          <Typography color="textSecondary" {...overviewProps}>
            {overview}
          </Typography>
        </Grid>
        <Grid item sm={1} xs={2}>
          <Box display="flex" justifyContent="center" alignItems="center" className={cls.root}>
            <ForwardIcon onClick={() => history.push(to)} className={cls.icon} />
          </Box>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="space-between" flexDirection="column" height="350px">
        {isLoading ? (
          <>
            <Box width="100%">
              <Skeleton width="100%" height="20px">
                <Typography>.</Typography>
              </Skeleton>
              <Skeleton width="100%" height="20px">
                <Typography>.</Typography>
              </Skeleton>
            </Box>
            <Skeleton width="100%" height="230px"></Skeleton>
          </>
        ) : (
          <>{children}</>
        )}
      </Box>
    </PaperWrapper>
  );
}
